import languages from "./languages";

const lang = {
  message: {
    hello: "hello world",
  },
  aboutNounsLove: "About Nouns Love",
  installMetaMask: "Please install MetaMask.",
  acceptingBits: "Now accepting bids",
  currentPrice: "Current Price",
  getNoun: "Get Your Nounish",
  heldBy: "Held by",
  winningPrice: "Winning Price",
  sorryLowPrice: "Sorry. Someone has won or the bid price is low.",
  sorryLowGasPrice:
    "Sorry. Your request is failed. Someone has won or the gas price is low.",
  invalidNetwork: "Invalid Netword",
  youNeetNet: "You need to connect to {networdName}",
  notFoundMessage:
    "404: This is not the person, place, or thing you're looking for...",
  languages,
};

export default lang;
